import { useEffect } from "react";
import { Button, Col, Form, Row, Space } from "antd";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";
import * as Request from "../commons/request";
import * as Common from "../commons/common";

import * as Utils from "../utils/utils";

import moment from "moment";

function DetailOrder({ order, requestGetOrders }: { order: Types.OrderDto; requestGetOrders: (...args: any[]) => Promise<true | undefined> }) {
    const requestAxiosUpdateDeliveryStatusDate = async (orderId: number, deliveryStatusDate: string) => {
        const response = await utilAxiosWithAuth().put(Request.ORDER_DELIVERY_STATUS_URL + "/" + orderId, { deliveryStatusDate });
        return response.data;
    };

    const {
        loading: loadingUpdateDeliveryStatusDate,
        error: errorUpdateDeliveryStatusDate,
        data: resultUpdateDeliveryStatusDate,
        execute: requestUpdateDeliveryStatusDate,
    } = useAsyncAxios(requestAxiosUpdateDeliveryStatusDate);

    useEffect(() => {
        if (resultUpdateDeliveryStatusDate === null) return;
        console.log("resultUpdateDeliveryStatusDate", resultUpdateDeliveryStatusDate);
        requestGetOrders();
    }, [resultUpdateDeliveryStatusDate]);

    useEffect(() => {
        if (errorUpdateDeliveryStatusDate === null) return;

        console.log("errorUpdateDeliveryStatusDate", errorUpdateDeliveryStatusDate);
    }, [errorUpdateDeliveryStatusDate]);

    const onToggleDeliveryStatus = () => {
        requestUpdateDeliveryStatusDate(order.orderId, order.deliveryStatusDate ? null : moment().format(Common.FORMAT_DATE_TIME));
    };

    const convertCurrency = (price: number | undefined) => {
        if (price === undefined) return "";
        return Utils.convertCurrencyKorean(price);
    };

    const getCarPriceVAT = (order: Types.OrderDto) => {
        let carPrice = 0;
        let carPriceVAT = 0;
        if (order.carType !== undefined) {
            carPrice += order.carType?.discountedPrice ? order.carType?.discountedPrice : order.carType.price;
            carPrice += order.carType?.discountedAdditionalPrice ? order.carType?.discountedAdditionalPrice : order.carType.additionalPrice;
        }
        if (order.color !== undefined) {
            carPrice += 0;
        }

        carPriceVAT = (carPrice / 100) * 10;

        if (order.options !== undefined) {
            order.options.forEach((option) => (carPrice += option.price));
        }

        return carPriceVAT;
    };

    const displayInfo = (content: string, price?: string | number, isLarge?: boolean) => {
        return (
            <Row justify={"space-between"} style={{ padding: "8px" }}>
                {isLarge ? (
                    <span className="b-lg" style={{ fontWeight: 700 }}>
                        {content}
                    </span>
                ) : (
                    <span>{content}</span>
                )}

                {isLarge ? (
                    <span className="b-lg" style={{ fontWeight: 700 }}>
                        {price}
                    </span>
                ) : (
                    <span>{price}</span>
                )}
            </Row>
        );
    };

    const displayPaymentStatus = (order: Types.OrderDto) => {
        return order.payments?.map((payment, index) => {
            return (
                <Row key={payment.paymentId}>
                    <Col xs={{ span: 24 }}>
                        <Form.Item className="searchForm" label="분류">
                            <span>{Utils.convertPaymentType(payment.paymentType)}</span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }}>
                        <Form.Item className="searchForm" label="상태">
                            <span>
                                {payment.paidDate ? (
                                    <>
                                        {!order.canceledDate && <span style={{ fontWeight: 700, color: "#006AF5" }}>결제 완료</span>}
                                        {order.canceledDate && <span style={{ fontWeight: 700, color: "#006AF5" }}>결제 취소</span>}
                                    </>
                                ) : (
                                    <>
                                        {order.canceledDate && <span style={{ fontWeight: 700, color: "#006AF5" }}>결제 취소</span>}
                                        {!order.canceledDate && <span style={{ fontWeight: 700, color: "#006AF5" }}>결제 대기</span>}
                                    </>
                                )}
                            </span>
                        </Form.Item>
                    </Col>
                    <Col xs={{ span: 24 }}>
                        <Form.Item className="searchForm" label="결제 금액">
                            <span>{convertCurrency(payment.amount)}</span>
                        </Form.Item>
                    </Col>
                    {order.payments !== undefined && order.payments.length > 0 && (
                        <Col xs={{ span: 24 }}>
                            <Form.Item className="searchForm" label="결제 일시">
                                <span>{payment.paidDate ? Utils.utcToLocalTime(payment.paidDate, Common.FORMAT_DATE_TIME) : String.dash}</span>
                            </Form.Item>
                        </Col>
                    )}
                    <Col xs={{ span: 24 }}>
                        <Form.Item className="searchForm" label="결제 수단">
                            <span>{payment.paidDate ? Utils.getPaymentType(payment) : String.dash}</span>
                        </Form.Item>
                    </Col>

                    {order.payments !== undefined && (index !== order.payments.length - 1 ? <hr /> : null)}
                </Row>
            );
        });
    };

    return (
        <div>
            <Row gutter={[20, 20]}>
                <Col xs={24} sm={24} md={12}>
                    <h3>주문정보</h3>
                    <Space direction="vertical" size="small" style={{ width: "100%" }}>
                        <Row>
                            <Col xs={{ span: 24 }}>
                                <Form.Item className="searchForm" label="ID">
                                    <span>
                                        {order.orderId} - {order.user?.name}
                                    </span>
                                </Form.Item>
                            </Col>
                            {order.payments !== undefined && order.payments.length > 0 && (
                                <Col xs={{ span: 24 }}>
                                    <Form.Item className="searchForm" label="다날주문번호">
                                        <span>{order.payments[0].paymentImp?.impUid || String.dash}</span>
                                    </Form.Item>
                                </Col>
                            )}
                            <Col xs={{ span: 24 }}>
                                <Form.Item className="searchForm" label="주문번호">
                                    <span>
                                        {order.orderNo} {order.canceledDate ? "- 주문취소" : ""}
                                    </span>
                                </Form.Item>
                            </Col>
                        </Row>

                        <div style={{ background: "white", padding: "8px" }}>
                            {displayInfo(
                                `${order.carType?.typeName} / ${order.color?.colorName}`,
                                convertCurrency(order.carType?.discountedPrice ? order.carType?.discountedPrice : order.carType?.price)
                            )}
                            {order.carType?.additionalPrice && order.carType?.additionalPrice > 0
                                ? displayInfo(
                                      `${order.carType?.additionalCompany}`,
                                      convertCurrency(
                                          order.carType?.discountedAdditionalPrice ? order.carType?.discountedAdditionalPrice : order.carType?.additionalPrice
                                      )
                                  )
                                : null}
                            {order.options && order.options.length > 0
                                ? order.options.map((option) => {
                                      return <div key={option.optionId}>{displayInfo(option.optionName, convertCurrency(option.price))}</div>;
                                  })
                                : null}
                            <hr />
                            {displayInfo("부가세(10%)", convertCurrency(getCarPriceVAT(order)))}
                            <hr />
                            {/* {displayInfo("전기차 보조금", "- " + convertCurrency(getSubsiby(order)))} */}
                            <div className="mt-2">{displayInfo("주문 금액", convertCurrency(order.totalPrice), true)}</div>
                            <hr />
                            {displayInfo("전기차 보조금(국고)", "- " + convertCurrency(order.nationalSubsidy?.price))}
                            {displayInfo(
                                "전기차 보조금(" + order.localSubsidy?.siGunGu.siDo.siDoName + " " + order.localSubsidy?.siGunGu.siGunGuName + ")",
                                "- " + convertCurrency(order.localSubsidy?.price)
                            )}
                        </div>
                    </Space>
                </Col>

                <Col xs={24} sm={24} md={12}>
                    {order.payments !== undefined && order.payments.length > 0 && (
                        <Row style={{ marginBottom: 20 }}>
                            <Col xs={{ span: 24 }}>
                                <h3>결제정보</h3>
                                <div className="box">{displayPaymentStatus(order)}</div>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col xs={{ span: 24 }}>
                            <h3>출고정보</h3>
                            <Row>
                                <Col xs={{ span: 24 }}>
                                    <Form.Item className="searchForm" label="출고상태">
                                        <Row justify="space-between">
                                            <span>{order.deliveryStatusDate ? "완료" : String.dash}</span>
                                            <Button onClick={onToggleDeliveryStatus}>{order.deliveryStatusDate ? "취소" : "완료"}</Button>
                                        </Row>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}

export default DetailOrder;
